import React, { useState } from 'react';
import './Home.css';
import Leaderboard from './Leaderboard';
import Stats from './stats';

const Home = ({ records, onEdit }) => {
    const [activeTab, setActiveTab] = useState('leaderboard');
    const [selectedPerson, setSelectedPerson] = useState(null);

    const handlePersonSelect = (name) => {
        setSelectedPerson(name);
        setActiveTab('stats');
    };

    return (
        <div className="home">
            <div className="header">
                <div className="header-content">
                    <h3 className={`item ${activeTab === 'leaderboard' ? 'active' : ''}`} onClick={() => setActiveTab('leaderboard')}>Leaderboard</h3>
                    <h3 className={`item ${activeTab === 'stats' ? 'active' : ''}`} onClick={() => setActiveTab('stats')}>Stats</h3>
                </div>
            </div>
            <div className="content">
                {activeTab === 'leaderboard' && <Leaderboard records={records} onPersonSelect={handlePersonSelect} />}
                {activeTab === 'stats' && <Stats records={records} onEdit={onEdit} selectedPerson={selectedPerson} />}
            </div>
        </div>
    );
};

export default Home;
